import type { ComponentProps } from "react";

export default function ReturnIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.92901 2.11614L2.11531 8.03804C1.96156 8.19459 1.96156 8.48692 2.11531 8.64336L7.92901 14.5587C8.20126 14.8063 8.58915 14.5815 8.60416 14.256L8.60416 10.9136C10.128 10.8347 11.9053 11.1924 13.4615 12.1637C15.1416 13.2122 16.5772 14.9559 17.2123 17.6841C17.2604 17.8806 17.459 18.0226 17.6503 17.997C17.8415 17.9714 18.0002 17.7817 18 17.5789C17.9856 13.5617 16.9056 10.6165 15.1304 8.63691C13.4374 6.74861 11.1325 5.76229 8.60387 5.49184L8.60387 2.41911C8.59645 2.02813 8.20906 1.87347 7.92872 2.11645L7.92901 2.11614ZM7.80392 3.41243L7.80392 5.80748C7.8073 6.05805 7.95936 6.26167 8.24753 6.30084C10.7425 6.51144 12.9487 7.43103 14.5489 9.21554C15.7428 10.5471 16.6095 12.3742 16.9871 14.7952C16.1814 13.2966 15.0857 12.1958 13.8738 11.4396C12.0552 10.3046 9.99303 9.93343 8.24753 10.0908C7.95422 10.1334 7.8045 10.2903 7.80375 10.5645L7.80375 13.2622L2.9712 8.34045L7.80392 3.41243Z"
        fill="currentColor"
      />
    </svg>
  );
}
